import {
  API_CONSOLIDATION_FINAL_SCORES,
  API_CONSOLIDATION_IMPORT_EXCEL,
  API_UNLOCK_CONSOLIDATION,
} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const importExcel = async (employeeId, reviewPeriodId, data) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: `${API_CONSOLIDATION_IMPORT_EXCEL}/${employeeId}/${reviewPeriodId}`,
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  } catch (error) {
    console.error('consolidationApi importExcel Error:', error.message);
  }
};

const unlockByPeriodIdAndEmployeeId = async (periodId, employeeId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: `${API_UNLOCK_CONSOLIDATION}/${periodId}/${employeeId}`,
    });
    return res.data;
  } catch (error) {
    console.error('consolidationApi unlockByPeriodIdAndEmployeeId Error:', error.message);
    return null;
  }
};

const getFinalScore = async (periodId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_CONSOLIDATION_FINAL_SCORES}/${periodId}`,
    });
    return res.data;
  } catch (error) {
    console.error('consolidationApi getFinalScore Error:', error.message);
    return null;
  }
};

const consolidationApi = {
  importExcel,
  unlockByPeriodIdAndEmployeeId,
  getFinalScore,
};

export default consolidationApi;
